import { documentsApi } from '../api'

const handleResponse = async response => {
  const { ok, status } = response

  if (ok && (status === 200 || status === 201)) {
    const data = await response.json()
    return { success: true, payload: data }
  }

  if (status === 204) {
    return { success: true }
  }

  if (status === 401) {
    const { authUtils } = await import('../utils')
    authUtils.clearAuthAndRedirect()
  }

  return { error: 'Falha ao processar requisição' }
}

const list = async (scheduleId, patientId) => {
  try {
    const response = await documentsApi.list(scheduleId, patientId)
    return handleResponse(response)
  } catch (e) {
    console.error(e)
    return { error: 'Falha ao listar arquivos' }
  }
}

const upload = async (files, scheduleId, patientId) => {
  try {
    const response = await documentsApi.upload(files, scheduleId, patientId)
    return handleResponse(response)
  } catch (e) {
    console.error(e)
    return { error: 'Falha ao fazer upload, tente novamente' }
  }
}

const remove = async id => {
  try {
    const response = await documentsApi.remove(id)
    return handleResponse(response)
  } catch (e) {
    console.error(e)
    return { error: 'Falha ao remover arquivo' }
  }
}

export default { list, upload, remove }
